
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { IModalComponent, FormButtonDisabler, Validations, DropdownField, Btn, Field, TextField } from '@samc/centricity-core';
  import { IPackageDocumentResponse, IPackageDocumentRequest } from './../Interfaces';
  import { DocumentTypeSource } from '@/Sources';
  import { AjaxHelper } from '@samc/common';
  import { PackageDocumentValidator } from '@/Validators';

  @Component({
    name: 'edit-document-modal',
    components: { FormButtonDisabler, Btn, Field, DropdownField, TextField }
  })
  export default class EditDocumentModalComponent extends Vue implements IModalComponent {
    @Prop() public addCloseProp!: (callback: () => Promise<boolean | undefined>) => void;
    @Prop() public closeProp!: () => void;
    @Prop() public id!: string;
    @Prop() public verificationToken!: string;
    @Prop({ required: true }) public packageType!: 'buy' | 'sell';
    @Prop({ required: true }) public packageId!: string;
    
    public documentTypeSource = new DocumentTypeSource(true);
    public loaded: boolean = false;
    public updateResult: boolean = false;
    public showValidations: boolean = false;
    public validator = new PackageDocumentValidator(false);
    public packageDocument: IPackageDocumentResponse = {
      documentName: '',
      packageId: '',
      id: '',
      packageDocumentType: { id: '', name: ''},
      documentTag: '',
      modifiedBy: '',
      internalId: null
    };
    public updatePackageDocument = { packageDocumentTypeId: null, documentTag: null} as any;


    public get queryParams(): any { return { packageType: this.packageType, packageId: this.packageId }; }
    public get validations(): Validations<IPackageDocumentRequest> { return this.validator.isValid(this.updatePackageDocument); }

    public async mounted() {
      this.verificationToken ??= await this.$verificationToken();
      const helper = new AjaxHelper('/packagedocument/document/' + this.id, this.verificationToken, null, null);
      try {
        const response = await helper.getData<IPackageDocumentResponse>('', this.queryParams);
        if (response) {
          this.packageDocument = response;
          this.updatePackageDocument.documentTag = response.documentTag;
          this.updatePackageDocument.packageDocumentTypeId = response.packageDocumentType?.id

          this.loaded = true;
        }
      }
      catch (err: any) {
        this.$alert.error('An error occurred getting document.');
      }

      this.addCloseProp(async () => {
        this.showValidations = true;
        if (Object.keys(this.validations).length === 0) {
          await this.updateChanges();
          return this.updateResult;
        }
      });
    }

    public async updateChanges() {
      try {
        this.$loading('Updating document');
        const request = {
          documentName: this.packageDocument.documentName,
          documentTag: this.updatePackageDocument.documentTag,
          id: this.packageDocument.id,
          internalId: this.packageDocument.internalId,
          packageDocumentTypeId: this.updatePackageDocument.packageDocumentTypeId,
          packageId: this.packageDocument.packageId,
          modifiedBy: $user ? $user?.name : '',
          createdBy: this.packageDocument.modifiedBy
        } as IPackageDocumentRequest;
        const helper = new AjaxHelper('/packagedocument/document/' + this.id, this.verificationToken, null, null);
        const response = await helper.patchData<IPackageDocumentResponse>('', request, this.queryParams);
        if (response) {
          this.updateResult = true;
        }
      }
      catch (err: any) {
        this.updateResult = false;
        this.$alert.error('An error occurred saving document.');
      }
      finally {
        this.$loading();
      }
    }

    public UnwrapString<T>(obj?: Validations<T> | string): Validations<T> | undefined {
      return typeof obj === 'object' ? obj as Validations<T> | undefined : undefined;
    }
  }
